import React, { FC, Fragment } from 'react';
import { permissions } from 'utils/permission';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { customerSettings } from 'utils/customerSettings';
import { CONSTANTS } from 'config/constants';
import ThreeShapeAuthContainer from './three-shape-auth-container.component';
import DexisAuthContainer from './dexis-auth-container.component';
import MeditAuthContainer from './medit-auth-container.component';
import PandaAuthContainer from './panda-auth-container.component';
import DsCoreAuthContainer from './ds-core-auth-container.component';
import PandaEuAuthContainer from './panda-eu-auth-container.component';

const ScannerCaseAuthContainer: FC = () => {
    const currentUser = currentUserVar();
    const currentOrganization = currentOrgVar();

    const isLabTech = () => {
        return permissions.isLabTechnician(currentUser.type) && !permissions.isExternalTechnician(currentUser.role);
    };

    const showThreeShapeAuth = () => {
        const isThreeShapeEnabled = customerSettings.getCustomerSetting(
            currentOrganization.customerSettings,
            CONSTANTS.SETTINGS_NAMES.THREE_SHAPE_INTEGRATION,
        );
        return isLabTech() && isThreeShapeEnabled;
    };

    const showMeditAuth = () => {
        const isMeditEnabled = customerSettings.getCustomerSetting(
            currentOrganization.customerSettings,
            CONSTANTS.SETTINGS_NAMES.MEDIT_INTEGRATION,
        );
        return isLabTech() && isMeditEnabled;
    };

    const showDexisAuth = () => {
        const isDexisEnabled = customerSettings.getCustomerSetting(
            currentOrganization.customerSettings,
            CONSTANTS.SETTINGS_NAMES.DEXIS_INTEGRATION,
        );
        return isLabTech() && isDexisEnabled;
    };

    const showPandaAuth = () => {
        const isPandaEnabled = customerSettings.getCustomerSetting(
            currentOrganization.customerSettings,
            CONSTANTS.SETTINGS_NAMES.PANDA_INTEGRATION,
        );
        return isLabTech() && isPandaEnabled;
    };

    const showPandaEULogin = () => {
        const isPandaEUEnabled = customerSettings.getCustomerSetting(
            currentOrganization.customerSettings,
            CONSTANTS.SETTINGS_NAMES.PANDA_INTEGRATION_EU,
        );
        return isLabTech() && isPandaEUEnabled;
    };

    const showDsCoreAuth = () => {
        const isDsCoreEnabled = customerSettings.getCustomerSetting(
            currentOrganization.customerSettings,
            CONSTANTS.SETTINGS_NAMES.DS_CORE_INTEGRATION,
        );
        return isLabTech() && isDsCoreEnabled;
    };

    return (
        <Fragment>
            {showThreeShapeAuth() ? <ThreeShapeAuthContainer /> : undefined}
            {showDexisAuth() ? <DexisAuthContainer /> : undefined}
            {showMeditAuth() ? <MeditAuthContainer /> : undefined}
            {showPandaAuth() ? <PandaAuthContainer /> : undefined}
            {showPandaEULogin() ? <PandaEuAuthContainer /> : undefined}
            {showDsCoreAuth() ? <DsCoreAuthContainer /> : undefined}
        </Fragment>
    );
};

export default ScannerCaseAuthContainer;
